import apiRoutes from "@/services/api/routes";

type ApiEntity = keyof typeof apiRoutes;

interface ApiParams {
  [key: string]: string;
}

interface ApiOptions {
  pathParams?: ApiParams;
  queryParams?: ApiParams;
}

function replacePlaceholders(
  url: string,
  params: Record<string, string>
): string {
  return url.replace(/:(\w+)/g, (_, key) => {
    if (params[key] === undefined) {
      throw new Error(`Missing parameter "${key}" for URL "${url}"`);
    }
    return encodeURIComponent(params[key]);
  });
}

function appendQueryParams(
  url: string,
  queryParams: Record<string, string>
): string {
  const searchParams = new URLSearchParams(queryParams).toString();
  if (!searchParams) return url;

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${searchParams}`;
}

export default function getApiEndpoint(
  entity: string,
  options?: ApiOptions
): string {
  const endpoint = apiRoutes[entity as ApiEntity];
  if (!endpoint) {
    throw new Error(`API endpoint for entity "${entity}" not found`);
  }

  let url: string = endpoint;
  if (options?.pathParams) {
    url = replacePlaceholders(url, options.pathParams);
  }
  if (options?.queryParams) {
    url = appendQueryParams(url, options.queryParams);
  }

  return url;
}
